import {styled, CSSObject} from "@mui/material/styles"
import merge from "lodash/merge"
import {Button} from "@mui/material"
import {removeUnsetProps} from "../utils"
import {ReadMoreStyles} from "../copy/models"

export const BannerColumn = styled("div")({
    display: "flex",
    flexDirection: "column",
})

export const BannerRow = styled("div")(({theme}) => ({
    display: "flex",
    flexDirection: "row",
    gap: "0.5rem",
    [theme.breakpoints.down("md")]: {
        flexDirection: "column",
        gap: "0",
    },
}))

export const SideImageContainer = styled("div")(({theme}) => {
    return {
        [theme.breakpoints.up("md")]: {
            width: "30%",
            flexBasis: "30%",
        },
    }
})

export const SideComponentsContainer = styled("div")(({theme}) => {
    return {
        display: "flex",
        flexDirection: "column",
        [theme.breakpoints.up("md")]: {
            width: "70%",
            flexBasis: "70%",
        },
    }
})

export const SearchBannerWrapper = styled("div", {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})<{$hasPreviousPage: boolean; $urlIsSaleOrClearance: boolean}>(({theme, $hasPreviousPage, $urlIsSaleOrClearance}) => {
    return {
        display: $hasPreviousPage ? "none" : "block",
        paddingLeft: "1rem",
        paddingRight: "1rem",
        width: "100%",
        [theme.breakpoints.down("lg")]: {
            padding: $urlIsSaleOrClearance ? "0 2rem" : "0 1rem",
        },
        [theme.breakpoints.down("md")]: {
            paddingLeft: "0",
            paddingRight: "0",
        },
    }
})

interface BannerStyles {
    backgroundColor: string
}

export const NoSearchBanner = styled("div", {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})<{$paddingTop: string}>(({theme, $paddingTop}) => ({
    paddingTop: `${$paddingTop}rem`,
    width: "100%",
    [theme.breakpoints.down("lg")]: {
        paddingTop: "0",
    },
}))

export const SearchBannerBody = styled("div", {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})<{$bannerStyles: BannerStyles; $copyOnly: boolean}>(({theme, $bannerStyles, $copyOnly}) => {
    const override = removeUnsetProps({
        backgroundColor: $bannerStyles?.backgroundColor,
    } as CSSObject)
    return merge(
        {
            backgroundColor: $copyOnly ? "none" : theme.colours.plp.searchBanner.default.banner.root.backgroundColor,
            display: $copyOnly ? "none" : "block",
            [theme.breakpoints.up("md")]: {
                paddingRight: "0",
                paddingLeft: "0",
            },
        },
        override,
    )
})

export const SearchBannerPadding = styled("div")<{$copyOnly: boolean; $imageOnly: boolean}>(
    ({theme, $copyOnly, $imageOnly}) => ({
        paddingTop: $copyOnly || $imageOnly ? "0" : "1rem",
        [theme.breakpoints.up("md")]: {
            paddingTop: $imageOnly ? "0" : "1rem",
        },
    }),
)

export const RegionNotFound = styled("div")(() => ({
    display: "none",
}))

export const StyledSBReadmoreButton = styled(Button, {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})<{$readMoreStyles?: ReadMoreStyles}>(({theme, $readMoreStyles}) => {
    const override = removeUnsetProps({
        color: $readMoreStyles?.readMoreColor,
        textTransform: $readMoreStyles?.readMoreTextTransform,
    } as CSSObject)
    return merge(
        {
            // match size of text
            height: "1em",
            textWrap: "nowrap",
            minWidth: "auto",
            lineHeight: 1,
            alignItems: "baseline",
            color: theme.colours.plp.searchBanner.default.banner.copyText.link.primary.enabled.contrastTextColor,
            flexShrink: 0,
            alignSelf: "end",
            marginRight: "1rem",
            marginBottom: "1rem",
            backgroundColor: "transparent",
            "&:hover": {
                backgroundColor: "transparent",
            },
            [theme.breakpoints.down("md")]: {
                display: "none",
            },
        } as CSSObject,
        override,
    )
})

export const PillsContainer = styled("div")`
    display: flex;
    flex-direction: column;
`
